import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUtils } from "../../services/utilsProvider";
import { useProject } from "./provider";
import styled from "styled-components";
import { Icon } from "../../ui";
import ProjectForm from "./ProjectForm";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
    svg {
      margin: 0 20px 0 10px;
    }
  }
`;

const EditNews = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { notify } = useUtils();

  const {
    state: { selected: project },
    fetchOne,
    dispatch,
  } = useProject();

  useEffect(() => {
    fetchOne(params.id, { langCode: params.langCode });
    return () => dispatch({ type: "set_selected", payload: null });
  }, [fetchOne, dispatch, params.id]);

  const handleSuccess = () => {
    navigate(-2);
    notify("Changes saved successfully");
  };

  if (!project || project.id !== Number(params.id)) return;
  return (
    <div id="edit-newS">
      <Grid>
        <h2 style={{ marginTop: "0" }}>Edit Project</h2>
        {/* <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          <span>Back</span>
          <Icon name="arrowLeft" />
        </div> */}
      </Grid>
      <ProjectForm project={project} handleSuccess={handleSuccess} />
    </div>
  );
};

export default EditNews;
